export default __webpack_public_path__ + "static/media/EP04_ERYTHREE.71a0889b.mp3";